import { request } from '../http'

interface WechatData {
  /**
   * 自定义参数/场景值
   */
  customParameters?: string
  /**
   * 调整链接
   */
  page?: string
}

interface EmailData {
  email: string
  emailVerificationCode: string
}

/**
 *  会员信息
 */
export function getMembershipInformation() {
  const methodInstance = request.Post<Service.ResponseResult<User.Membercenter.MemberShipInfo>>('/user/membercenter/getMembershipInformation')
  return methodInstance
}

/**
 *  完成新手任务（以 token 更新新手任务状态为完成）
 */
export function completeNewbieTask() {
  const methodInstance = request.Get<Service.ResponseResult<any>>('/user/membercenter/completeNewbieTask')
  return methodInstance
}

/**
 *  生成小程序二维码图片
 */
export function generateQRCodeForWeChatMiniProgram(data: WechatData) {
  const methodInstance = request.Post<Service.ResponseResult<Blob>>('/user/weChatOfficialAccount/generateQRCodeForWeChatMiniProgram', data)
  methodInstance.meta = {
    // 标识为blob数据
    isBlob: true,
  }
  return methodInstance
}

/**
 *  切换账号
 */
export function switchAccounts(data: { targetUsername: string }) {
  const methodInstance = request.Post<Service.ResponseResult<Service.RequestError>>('/user/membercenter/switchAccounts', data)
  return methodInstance
}

/**
 *  切回账号
 */
export function switchAccountsBack() {
  const methodInstance = request.Get<Service.ResponseResult<Service.RequestError>>('/user/membercenter/switchAccountsBack')
  return methodInstance
}

/**
 * 文件上传返回信息
 */
export interface UploadFileResult {
  /**
   * 文件访问地址
   */
  url?: string;
  /**
   * 原始文件名
   */
  originalFilename?: string;
  [property: string]: any;
}

/**
 *  文件上传
 */
export function uploadFileForCertificate(data: FormData) {
  const methodInstance = request.Post<Service.ResponseResult<UploadFileResult>>('/user/aliController/uploadFileForCertificate', data)
  return methodInstance
}

/**
 * 文件上传参数
 */
export interface UploadFileParam {
  uploadFileConfigurationCode: string
  fileManagementParam: {
    moduleCategory: string
    moduleDataId: number | string
    categoryTypeDataId: null
    categoryType: string
  }
  fileParams: Record<string, string>
}

/**
 *  通用文件上传(表单提交成功后,使用返回id上传附件)
 */
export function uploadFile(data: FormData) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/file-management/file/upload', data)
  return methodInstance
}

/**
 *  查询个人账户余额信息
 */
export function accountGetInfo() {
  const methodInstance = request.Post<Service.ResponseResult<AccountInfo>>('/finance/account/getInfo')
  return methodInstance
}

/**
 *  文件查询(根据模块查询出下面所有的文件)
 */
export function getFileByModuleCategory(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<FileInfo>>(`/file-management/file/getFileNameWithCategory`, data)
  return methodInstance
}

/**
 *  文件查询(精准查询)
 */
export function getFileById(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<FileInfo>>(`/file-management/file/getFileName`, data)
  return methodInstance
}

/**
 *  获取文件流
 */
export function getFileStream(data: any) {
  const methodInstance = request.Get<Service.ResponseResult<Blob>>(`/file-management/file/getFileStream?id=${data}`)
  methodInstance.meta = {
    isBlob: true,
  }
  return methodInstance
}

/**
 *  记录id查询文件信息
 */
export function getFileInfoById(data: any) {
  const methodInstance = request.Get<Service.ResponseResult<any>>(`/file-management/fileTransition/getFileInfoById?id=${data}`)
  return methodInstance
}

/**
 *  下载文件压缩包
 */
export function getFileZipByIdList(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<any>>(`/file-management/fileTransition/getFileZipByIdList`, data)
  methodInstance.meta = {
    isBlob: true,
  }
  return methodInstance
}

/**
 *  查询所有文件层级列表
 */
export function getRecursiontFilePre(data: Search.ReportDocument.Search) {
  const methodInstance = request.Post<Service.ResponseResult<any>>(`/file-management/fileTransition/getRecursiontFilePre`, data)
  return methodInstance
}

/**
 *  通过token获取登录信息
 */
export function getLoginInfoByToken() {
  const methodInstance = request.Get<Service.ResponseResult<User.Membercenter.MemberShipInfo>>('/user/membercenter/getLoginInfoByToken')
  return methodInstance
}

/**
 *  提交反馈
 */
export function addInpSearchRecord(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<any>>(`/backstage-management/brankinfo/addInpSearchRecord`, data)
  return methodInstance
}

/**
 *  绑定邮箱
 */
export function bindingEmail(data: EmailData) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/user/membercenter/bindingEmail', data)
  return methodInstance
}

/**
 *  通过分类查询列表
 */
export function getByClassname(data: any) {
  const methodInstance = request.Get<Service.ResponseResult<any>>(`/user/common/winiisDatalist/getByClassname?classname=${data}`)
  return methodInstance
}
